export const CONFIG_INTERFACE_LANGUAGES_ENABLED = 'interfaceLanguage.enabled';
export const CONFIG_INTERFACE_LANGUAGES = 'interfaceLanguage.languages';
export const CONFIG_INTERFACE_CURRENT_LANGUAGE = 'interfaceLanguage.currentLanguage';
export const CONFIG_INTERFACE_PREFERRED_LANGUAGE = 'interfaceLanguage.preferredLanguages';
export const CONFIG_USER_LOCATION = 'location';
export const FEATURE_FLAG_MULTILANGUAGE_ENABLED = 'features.app.multilanguage.enabled';
export const FEATURE_FLAG_MULTILANGUAGE_PAGES = 'features.app.multilanguage.supportedPages';
export const FEATURE_FLAG_MULTILANGUAGE_UNSUPPORTED_PAGES_REGEX = 'features.app.multilanguage.unsupportedPagesRegex';
